<template>
  <v-container>
    <h3 class="page-title no-print">預約清冊通知</h3>
    <v-row class="summary-row mb-4">
      <v-col cols="8" class="summary-left mt-3">
        <div class="summary-item">預約數：{{ summary.reservationCount }}</div>
        <div class="summary-item">
          預約日期：{{ (summary.targetDates || []).join("、") || "-" }}
        </div>
      </v-col>
      <v-col cols="4" class="text-right no-print">
        <v-btn color="primary" @click="printPage">列印清單</v-btn>
      </v-col>
    </v-row>

    <div class="print-table-area">
      <v-data-table
        :headers="headers"
        :items="summary.reservations || []"
        :items-per-page="-1"
        hide-default-footer
        no-data-text="查無資料"
        dense
        :mobile-breakpoint="0"
        :footer-props="{
          itemsPerPageText: '每頁幾筆',
          itemsPerPageOptions: [10, 30, -1],
        }"
      >
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "ReserveListNotify",
  data: () => ({
    isPrinting: false,
    printPageStyleEl: null,
    windowKey: "",
    owner: "",
    summary: {
      targetDates: [],
      sectionCount: 0,
      reservationCount: 0,
      reservations: [],
    },
    headers: [
      // { text: "院所帳號", value: "owner" },
      // { text: "行政區", value: "行政區" },
      // { text: "場次日期", value: "場次日期" },
      { text: "地點", value: "地點" },
      { text: "時段", value: "timeSlot" },
      { text: "姓名", value: "姓名" },
      { text: "身分證字號", value: "身分證字號" },
      { text: "電話", value: "電話" },
      { text: "建議時間", value: "建議時間" },
      { text: "篩檢項目", value: "篩檢項目" },
    ],
  }),
  created() {
    this.windowKey = (this.$route.query.windowKey || "").toString();
    this.owner = (this.$route.query.owner || "").toString();
    this.load();
  },
  mounted() {
    this.mountPrintPageStyle();
    window.addEventListener("beforeprint", this.onBeforePrint);
    window.addEventListener("afterprint", this.onAfterPrint);
  },
  beforeDestroy() {
    window.removeEventListener("beforeprint", this.onBeforePrint);
    window.removeEventListener("afterprint", this.onAfterPrint);
    this.unmountPrintPageStyle();
  },
  methods: {
    mountPrintPageStyle() {
      if (this.printPageStyleEl) return;
      const styleEl = document.createElement("style");
      styleEl.type = "text/css";
      styleEl.setAttribute("data-page-print", "reserve-list-notify");
      styleEl.textContent = "@page { size: landscape; }";
      document.head.appendChild(styleEl);
      this.printPageStyleEl = styleEl;
    },
    unmountPrintPageStyle() {
      if (!this.printPageStyleEl) return;
      this.printPageStyleEl.remove();
      this.printPageStyleEl = null;
    },
    onBeforePrint() {
      this.isPrinting = true;
    },
    onAfterPrint() {
      this.isPrinting = false;
    },
    printPage() {
      this.onBeforePrint();
      this.$nextTick(() => {
        window.print();
      });
    },
    async load() {
      if (!this.windowKey) {
        this.$toast.error("缺少寄送視窗參數，請由通知信連結進入");
        return;
      }
      const params = { windowKey: this.windowKey };
      if (this.owner) {
        params.owner = this.owner;
      }
      this.$vloading.show();
      try {
        const result = (
          await this.axios.get("/dashboard/reserveListNotify", { params })
        ).data;
        result.reservations = (result.reservations || []).map((row) => ({
          ...row,
          timeSlot: `${row.開始時間 || ""}-${row.結束時間 || ""}`,
        }));
        this.summary = result;
      } catch (error) {
        this.$toast.error("載入失敗");
      } finally {
        this.$vloading.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.summary-left {
  text-align: left;
}

.summary-center {
  text-align: center;
}

.summary-right {
  text-align: right;
}

.summary-item {
  margin-right: 50px;
  display: inline-block;
}

@media (max-width: 600px) {
  .summary-left,
  .summary-center,
  .summary-right {
    text-align: left;
  }
}

@media print {
  .no-print {
    display: none !important;
  }

  .print-table-area {
    margin-top: 0 !important;
  }

  ::v-deep .v-data-footer {
    display: none !important;
  }
}
</style>
